module.exports = __webpack_public_path__ + "static/media/FreeStylePart3.cea18e6d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/FreeStyle/FreeStylePart3.mp3
// module id = 133
// module chunks = 0